import { BaseDataService } from './BaseDataService';
import { Style, SurveyVersion } from '../../models';
import { NotificationService } from '../../services';

export class StyleDataService extends BaseDataService<Style> {
    private stylesBySurveyVersionMemoized: object = {};

    constructor(notificationService: NotificationService) {
        super('Style', 'Styles', notificationService);
    }

    public getAllBySurveyVersionId(surveyVersionId: number): Promise<any> {
        if (this.stylesBySurveyVersionMemoized[surveyVersionId]) {
            return this.stylesBySurveyVersionMemoized[surveyVersionId];
        }

        const endpoint = `${this.endpointRoot}/bysurveyversion/${surveyVersionId}`;
        const init = this.buildRequestInit('GET');

        const stylesPromise = fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json().then((styles: Style[]) => {
                    return this.sortStyles(styles);
                });
            }

            const message = `Error retrieving styles.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });

        this.stylesBySurveyVersionMemoized[surveyVersionId] = stylesPromise;
        return stylesPromise;
    }

    public getBySurveyInstance(id: string): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurveyinstance/${id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json().then((styles: Style[]) => {
                    return this.sortStyles(styles);
                });
            }

            const message = `Error retrieving styles.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAll(): Promise<any> {
        return super.getAll().then((styles: Style[]) => {
            return this.sortStyles(styles);
        });
    }

    private sortStyles(styles: Style[]): Style[] {
        if (!styles || !Array.isArray(styles)) {
            return styles;
        }

        return styles.sort((a, b) => {
            if (a.sort < b.sort) {
                return -1;
            }
            if (a.sort > b.sort) {
                return 1;
            }
            return 0;
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/services/api/StyleDataService.tsx